<mat-icon
  class="__icon  c-uploading-icon-icon">
  cloud_upload
</mat-icon>

<span class="__text  c-uploading-icon-text">uploading</span>
